export default __webpack_public_path__ + "static/media/promocionAlarma4Mobile.1db5b148.png";